import { normalize, schema } from 'normalizr'
import { createSelector } from 'reselect'
import {
  IOrganization,
  IOrganizationsState,
  IOrgObj,
  IStateMetadata,
  IStoreState,
  LOCAL_STORAGE_CURRENT_ORGANIZATION_KEY,
  IOrganizationLegalEntityState
} from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import * as constants from '../../constants/'
import { IOrganizationActions } from '../../actions/organizations'

const initOrganizationsState: IOrganizationLegalEntityState = {
  entity: {
    addressLine1: '',
    addressLine2: '',
    businessName: '',
    businessTaxId: 0,
    city: '',
    firstName: '',
    lastName: '',
    postalCode: '',
    state: '',
    type: ''
  },
  metadata: {
    fetching: false,
    fetchingError: '',
    fetchingSuccess: '',
    processing: false,
    processingError: '',
    processingSuccess: ''
  }
}

export function organizationLegalEntity(
  state: IOrganizationLegalEntityState = initOrganizationsState,
  action: IOrganizationActions
): IOrganizationLegalEntityState {
  const metadata = {
    fetching: false,
    fetchingError: '',
    fetchingSuccess: '',
    processing: false,
    processingError: '',
    processingSuccess: ''
  }
  switch (action.type) {
    case constants.GET_ORGANIZATION_LEGAL_ENTITY_REQUEST:
      metadata.processing = true
      return Object.assign({}, state, { metadata })
    case constants.GET_ORGANIZATION_LEGAL_ENTITY_SUCCESS:
      metadata.processing = false
      metadata.processingSuccess = UIMessages.organization.bankAccount.successfullyRemoved
      return Object.assign({}, state, { entity: action.payload, metadata })
    case constants.GET_ORGANIZATION_LEGAL_ENTITY_FAILURE:
      metadata.processing = false
      metadata.processingError = action.payload
      return Object.assign({}, state, { metadata })
    case constants.CLEAR_ORGANIZATION_LEGAL_ENTITY:
      metadata.processing = false
      return Object.assign({}, state, { entity: null, metadata })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/organizations/legal-entity.ts